export default "__VITE_ASSET__BHcEaPIb__"